import type { FC } from "react";
import type { Translate } from "app/filters/i18nFilter";
import { i18nFilter } from "app/filters/i18nFilter";
import { AdNetworksTableSingle } from "app/pages/website-analysis/traffic-sources/display-ads/ad-networks/AdNetworksTableSingle";
import { AdNetworksTableCompare } from "app/pages/website-analysis/traffic-sources/display-ads/ad-networks/AdNetworksTableCompare";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export interface IAdNetworksTableProps {
    i18n: Translate;
    applyUpdateParams: any;
    params: any;
}

export const AdNetworksContainer: FC = () => {
    const i18n = i18nFilter();
    const params = proNavigator.getParams();
    const isCompare = params.key.split(",").length > 1;

    const commonProps = {
        i18n,
        applyUpdateParams: proNavigator.applyUpdateParams.bind(proNavigator),
        params,
    };

    return isCompare ? <AdNetworksTableCompare {...commonProps} /> : <AdNetworksTableSingle {...commonProps} />;
};
